// Action types
import { createRequestTypes } from "../../utils";

export const VALIDATE_COUPON = createRequestTypes("VALIDATE_COUPON");

// Action creators

export const validateCouponRequest = (payload) =>
  ({ type: VALIDATE_COUPON.REQUEST, payload });

export const validateCouponSuccess = (payload) =>
  ({ type: VALIDATE_COUPON.SUCCESS, payload });

export const validateCouponFailure = (error) =>
  ({ type: VALIDATE_COUPON.FAILURE, payload: error });


export const CLEAR_COUPON_DISCOUNT = "CLEAR_COUPON_DISCOUNT";

export const clearCouponDiscount = () =>
  ({ type: CLEAR_COUPON_DISCOUNT });


